import { useCookies } from "react-cookie";
import {useEffect, useState} from 'react'
import ReactGA from "react-ga4";
import React from "react";
function useIsClient() {
  const [isClient, setIsClient] = useState(false);
  
  useEffect(() => {
    setIsClient(true);
  }, []);
  
  return isClient;
} 


export function useCookieHandler() {
    const isClient = useIsClient();


  const [cookies, setCookie] = useCookies(["cookieAccepted", "analyticsAllowed","userInteracted"]);
   
  const handleAccept = () => {
      if (!isClient) return null;

    setCookie("userInteracted", true, { path: "/", maxAge: 60 * 60 * 24 * 90 });
  
  };

  const handleReject = () => {
      if (!isClient) return null;

    setCookie("userInteracted", true, { path: "/", maxAge: 60 * 60 * 24 * 90 });
 
  };

  const handlePreferences = (isCookieAccepted,isAnalyticsAllowed)=>{
      if (!isClient) return null;

    if(isCookieAccepted){
    setCookie("cookieAccepted", true, { path: "/", maxAge: 60 * 60 * 24 * 90 });
    
  }else{
      setCookie("cookieAccepted", false, { path: "/", maxAge: 60 * 60 * 24 * 90 });
 
    }
    if(isAnalyticsAllowed){
    setCookie("analyticsAllowed", true, { path: "/", maxAge: 60 * 60 * 24 * 90 });

    }else{
       setCookie("analyticsAllowed", false, { path: "/", maxAge: 60 * 60 * 24 * 90 });
    removeGACookies();
    } 
  }
  useEffect(()=>{
        if (!isClient) return;

   if(!cookies.userInteracted){
        setCookie("cookieAccepted", true, { path: "/", maxAge: 60 * 60 * 24 * 90 });
    setCookie("analyticsAllowed", true, { path: "/", maxAge: 60 * 60 * 24 * 90 });

    setCookie("userInteracted", false, { path: "/", maxAge: 60 * 60 * 24 * 90 });

   }
  },[isClient])
  function removeGACookies() {
      if (!isClient) return null;

    document.cookie = "_ga=; Max-Age=0; path=/;";
    document.cookie = "_gid=; Max-Age=0; path=/;";
    document.cookie = "_gat=; Max-Age=0; path=/;";

    document.cookie.split(";").forEach((c) => {
      if (c.trim().startsWith("_ga_")) {
        document.cookie = `${c.split("=")[0]}=; Max-Age=0; path=/;`;
      }
    });
  }

  return { cookies, handleAccept, handleReject,handlePreferences };
}
